import moment from 'moment-timezone'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const reducer = (state, action) => {
  switch (action.type) {
    case 'date':
      return {
        ...state,
        date: action.payload,
      }
    case 'error':
      return {
        ...state,
        error: action.payload,
      }

    default:
      break
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const initialState = (timeZone) => {
  const fromDate =
    timeZone ?
      moment().parseZone().tz(timeZone, false).format('YYYY-MM-DDT00:00:00.000Z')
    : moment().format('YYYY-MM-DDT00:00:00.000Z')
  const toDate =
    timeZone ?
      moment().parseZone().tz(timeZone, false).format('YYYY-MM-DDT23:59:59.000Z')
    : moment().format('YYYY-MM-DDT23:59:59.000Z')

  return { date: { fromDate, toDate, isDateUpdated: false }, error: '', timeZone }
}
